import {SCREEN_NAMES} from '/enum/tealium.enum';

export const getReportName = (isViewTeam: boolean, activeTab: string) => {
  if (isViewTeam) return SCREEN_NAMES.coachTeamsReport;

  return activeTab === 'my-teams'
    ? SCREEN_NAMES.myTeamsReport
    : SCREEN_NAMES.watchListTeamsReport;
};
